<template>
<div id="reporte_bitacora_archivosm">
    <div>
        <v-breadcrumbs :items="breadcrumbs">
            <v-icon slot="divider">forward</v-icon>
        </v-breadcrumbs>
    </div>

    <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12>
        <base-material-card color="primary" icon="library_books" title="Consulta Directa Archivos M" class="elevation-1 px-5 py-3" >
          <v-form ref="form" lazy-validation>
            <v-card-text>
              <v-card-title>
                <span class="headline" ></span>
              </v-card-title>

                            <v-container grid-list-md text-xs-center>

                                <v-row row wrap>
                                    <v-col sm="12" md="4" lg="4">
                                        <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                            <template v-slot:activator="{ on }">
                                                <v-text-field v-on="on" v-model="model.fecha_de" label="Fecha Inicial" color="secondary" prepend-icon="event" @blur="
                                                                    model.fecha_de = parseDate(model.fecha_de)
                                                                    " v-mask="'####-##-##'" :rules="[
                                                                    rules.required,
                                                                    validaDias,
                                                                    validaFecha,
                                                                    $rules.validaDiasConsulta(model.fecha_de, model.fecha_a)
                                                                    ]">
                                                </v-text-field>
                                            </template>

                                            <v-date-picker v-model="model.fecha_de" color="secondary" landscape scrollable locale="es-mx" @input="menu1 = false">
                                                <v-spacer />

                                                <v-btn color="secondary" large @click="menu1 = false">
                                                    Cancelar
                                                </v-btn>
                                            </v-date-picker>
                                        </v-menu>
                                    </v-col>
                                    <v-col sm="12" md="4" lg="4">
                                        <v-menu ref="menu2" v-model="menu2" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                            <template v-slot:activator="{ on }">
                                                <v-text-field v-on="on" v-model="model.fecha_a" label="Fecha Final" color="secondary" prepend-icon="event" @blur="model.fecha_a = parseDate(model.fecha_a)" v-mask="'####-##-##'" :rules="[
                                                        rules.required,
                                                        validaDias,
                                                        validaFecha,
                                                        $rules.validaDiasConsulta(model.fecha_de, model.fecha_a)
                                                        ]"></v-text-field>
                                            </template>
                                            <v-date-picker v-model="model.fecha_a" color="secondary" landscape scrollable locale="es-mx" @input="menu2 = false">
                                                <v-spacer />

                                                <v-btn color="secondary" large @click="menu2 = false">
                                                    Cancelar
                                                </v-btn>
                                            </v-date-picker>
                                        </v-menu>
                                    </v-col>
                                    <v-col sm="12" md="2" lg="2">
                                        <v-switch
                                            v-model="fecha_factura"
                                            color="red darken-3"
                                            label="Fecha de Pedimento"
                                        ></v-switch>
                                    </v-col>
                                </v-row>
                                <v-row row wrap >
                                        <v-col sm="12" md="8" lg="8" v-if="es_grupo==0">
                                            <v-autocomplete :hide-no-data="true" :items="gruposTransportistas" v-model="rfc_grupo_seleccionado" 
                                                :item-text="getNombreGrupo" item-value="rfc" clearable label="Seleccione Emisor" ></v-autocomplete>
                                        </v-col>
                                        <v-col sm="12" md="8" lg="8" v-else >
                                            <v-autocomplete :hide-no-data="true" :items="clientesTransportista" v-model="rfc_cliente_seleccionado" 
                                                :item-text="getNombreCliente" item-value="rfc" clearable label="Seleccione Cliente" ></v-autocomplete>
                                        </v-col>
                                        <v-col sm="12" md="2" lg="2">                                             
                                            &nbsp;
                                        </v-col>
                                        <v-col sm="12" md="2" lg="2">
                                            &nbsp;
                                        </v-col>
                                    </v-row>
                                <v-row>
                                    <v-col>
                                        <v-checkbox v-model="selecciona_todo" label="Seleccionar Todo" @change="seleccionaTodo()" ></v-checkbox>
                                    </v-col>
                                </v-row>

                            </v-container>
                        </v-card-text>

                        <v-card-text>
                        <span><strong>Tablas con información a nivel pedimento</strong></span>
                        <v-container grid-list-md text-xs-center>
                            <v-row no-gutters dense style="margin-bottom: -35px;" >
                            <v-col>
                                <v-checkbox v-model="model.tablas" label="501 Datos Generales" value="501" :rules="[verificaTablas]" ></v-checkbox>
                            </v-col>
                            <v-col>
                                <v-checkbox v-model="model.tablas" label="502 Transporte de Mercancías" value="502" ></v-checkbox>
                            </v-col>
                            </v-row>
                            <v-row no-gutters dense style="margin-bottom: -35px;" >
                            <v-col>
                                <v-checkbox v-model="model.tablas" label="503 Guías" value="503" ></v-checkbox>
                            </v-col>
                            <v-col>
                                <v-checkbox v-model="model.tablas" label="504 Contenedores" value="504" ></v-checkbox>
                            </v-col>
                            </v-row>
                            <v-row no-gutters dense style="margin-bottom: -35px;" >
                            <v-col>
                                <v-checkbox v-model="model.tablas" label="505 Facturas" value="505" ></v-checkbox>
                            </v-col>
                            <v-col>
                                <v-checkbox v-model="model.tablas" v-if="es_grupo==0" label="506 Fechas del Pedimento" value="506" ></v-checkbox>
                            </v-col>
                            </v-row>
                            <v-row no-gutters dense style="margin-bottom: -35px;"  v-if="es_grupo==0">
                            <v-col>
                                <v-checkbox v-model="model.tablas" v-if="es_grupo==0" label="507 Casos del Pedimento" value="507" ></v-checkbox>
                            </v-col>
                            <v-col>
                                <v-checkbox v-model="model.tablas" v-if="es_grupo==0" label="508 Cuentas Aduaneras Garantía Pedimento" value="508" ></v-checkbox>
                            </v-col>
                            </v-row>
                            <v-row no-gutters dense style="margin-bottom: -35px;"  v-if="es_grupo==0">
                            <v-col>
                                <v-checkbox v-model="model.tablas" v-if="es_grupo==0" label="509 Tasas del Pedimento" value="509" ></v-checkbox>
                            </v-col>
                            <v-col>
                                <v-checkbox v-model="model.tablas" v-if="es_grupo==0" label="510 Contribuciones del Pedimento" value="510" ></v-checkbox>
                            </v-col>
                            </v-row>
                            <v-row no-gutters dense style="margin-bottom: -35px;"  v-if="es_grupo==0">
                            <v-col>
                                <v-checkbox v-model="model.tablas" v-if="es_grupo==0" label="511 Observaciones del Pedimento" value="511" ></v-checkbox>
                            </v-col>
                            <v-col>
                                <v-checkbox v-model="model.tablas" v-if="es_grupo==0" label="512 Descargos de Mercancía" value="512" ></v-checkbox>
                            </v-col>
                            </v-row>
                            <v-row no-gutters dense style="margin-bottom: -35px;"  v-if="es_grupo==0">
                            <v-col>
                                <v-checkbox v-model="model.tablas" v-if="es_grupo==0" label="513 Compensaciones" value="513" ></v-checkbox>
                            </v-col>
                            <v-col>
                                <v-checkbox v-model="model.tablas" v-if="es_grupo==0" label="514 Documentos que Amparan las Formas de Pago Virtuales" value="514" ></v-checkbox>
                            </v-col>
                            </v-row>
                            <v-row no-gutters dense style="margin-bottom: -35px;"  v-if="es_grupo==0">
                                <v-col>
                                <v-checkbox v-model="model.tablas" v-if="es_grupo==0" label="515 Informe de la Industria Automotriz" value="515" ></v-checkbox>
                            </v-col>
                            <v-col>
                                <v-checkbox v-model="model.tablas" v-if="es_grupo==0" label="516 Candados" value="516" ></v-checkbox>
                            </v-col>
                            </v-row>
                            <v-row no-gutters dense style="margin-bottom: -35px;"  v-if="es_grupo==0">
                            <v-col>
                                <v-checkbox v-model="model.tablas" v-if="es_grupo==0" label="520 Destinatarios de la Mercancía" value="520" ></v-checkbox>
                            </v-col>
                            <v-col>
                                <v-checkbox v-model="model.tablas" v-if="es_grupo==0" label="701 Rectificaciones" value="701" ></v-checkbox>
                            </v-col>
                            </v-row>
                            <v-row no-gutters dense style="margin-bottom: -35px;"  v-if="es_grupo==0">
                            <v-col>
                                <v-checkbox v-model="model.tablas" v-if="es_grupo==0" abel="702 Diferencias de Contribuciones del Pedimento" value="702" ></v-checkbox>
                            </v-col>
                            <v-col>
                                <v-checkbox v-model="model.tablas" v-if="es_grupo==0" label="601 Datos Generales del Previo de Consolidado" value="601" ></v-checkbox>
                            </v-col>
                            </v-row>
                            <v-row no-gutters dense style="margin-bottom: -35px;"  v-if="es_grupo==0">
                            <v-col>
                                <v-checkbox v-model="model.tablas" v-if="es_grupo==0" label="301 Datos Generales del Pedimento Complementario" value="301" ></v-checkbox>
                            </v-col>
                            <v-col>
                                <v-checkbox v-model="model.tablas" v-if="es_grupo==0" label="302 Prueba Suficiente" value="302" ></v-checkbox>
                            </v-col>
                            </v-row>
                            <v-row no-gutters dense style="margin-bottom: -35px;"  v-if="es_grupo==0">
                                <v-col>
                                <v-checkbox v-model="model.tablas" v-if="es_grupo==0" label="800 Electrónica de Pedimento" value="800" ></v-checkbox>
                                </v-col>
                                <v-col>
                                </v-col>
                            </v-row>

                        </v-container>
                    </v-card-text>
                </v-form>

                <v-card-text>
                    <span><strong>Tablas con información a nivel de partida (secuencia de la fracción arancelaria)</strong></span>
                    <v-container grid-list-md text-xs-center>
                    <v-row no-gutters dense style="margin-bottom: -35px;" >
                        <v-col>
                        <v-checkbox v-model="model.tablas" label="551 Partidas" value="551" ></v-checkbox>
                        </v-col>
                        <v-col>
                        <v-checkbox v-model="model.tablas" v-if="es_grupo==0" label="552 Mercancías" value="552" ></v-checkbox>
                        </v-col>
                    </v-row>
                    <v-row no-gutters dense style="margin-bottom: -35px;" >
                        <v-col>
                        <v-checkbox v-model="model.tablas" v-if="es_grupo==0" label="553 Permisos de la Partida" value="553" ></v-checkbox>
                        </v-col>
                        <v-col>
                        <v-checkbox v-model="model.tablas" v-if="es_grupo==0" label="554 Casos de la Partida" value="554" ></v-checkbox>
                        </v-col>
                    </v-row>
                    <v-row no-gutters dense style="margin-bottom: -35px;" >
                        <v-col>
                        <v-checkbox v-model="model.tablas" v-if="es_grupo==0" label="555 Cuentas Aduaneras de Garantía de la Partida" value="555" ></v-checkbox>
                        </v-col>
                        <v-col>
                        <v-checkbox v-model="model.tablas" v-if="es_grupo==0" label="556 Tasas de las Contribuciones de la Partida" value="556" ></v-checkbox>
                        </v-col>
                    </v-row>
                    <v-row no-gutters dense style="margin-bottom: -35px;" >
                        <v-col>
                        <v-checkbox v-model="model.tablas" v-if="es_grupo==0" label="557 Contribuciones de la Partida" value="557" ></v-checkbox>
                        </v-col>
                        <v-col>
                        <v-checkbox v-model="model.tablas" v-if="es_grupo==0" label="558 Observaciones de la Partida" value="558" ></v-checkbox>
                        </v-col>
                    </v-row>
                    <v-row no-gutters dense style="margin-bottom: -35px;" >
                        <v-col>
                        <v-checkbox v-model="model.tablas" v-if="es_grupo==0" label="560 Partidas del Informe de Industria Automotriz" value="560" ></v-checkbox>
                        </v-col>
                        <v-col>
                            &nbsp;
                        </v-col>
                    </v-row>
                    <v-row no-gutters dense style="margin-bottom: -35px;" >
                        <v-col>
                        <v-checkbox v-model="model.tablas" v-if="es_grupo==0" label="351 Determinación de contribuciones a nivel partida al amparo del Art. 2.5 del T-MEC (Pedimento CT)" value="351" ></v-checkbox>
                        </v-col>
                        <v-col>
                        <v-checkbox v-model="model.tablas" v-if="es_grupo==0" label="352 Detalle de importaciones a EUA/CAN para el pedimento complementario al amparo del Art. 2.5 del T-MEC" value="352" ></v-checkbox>
                        </v-col>
                    </v-row>
                    <v-row no-gutters dense style="margin-bottom: -35px;" >
                        <v-col>
                        <v-checkbox v-model="model.tablas" v-if="es_grupo==0" label="353 Determinación y/o pago de contribuciones a nivel partida por aplicación de los Artículos 2.5 T-MEC, 14 de la Decisión o 15 del TLCAELC" value="353" ></v-checkbox>
                        </v-col>
                        <v-col>
                        <v-checkbox v-model="model.tablas" v-if="es_grupo==0" label="355 Pago de contribuciones por aplicación del Art. 2.5 T-MEC a nivel partida" value="355" ></v-checkbox>
                        </v-col>
                    </v-row>
                    <v-row no-gutters dense style="margin-bottom: -35px;" >
                        <v-col>
                        <v-checkbox v-model="model.tablas" v-if="es_grupo==0" label="358 Observaciones a nivel partida para el Pedimento Complementario" value="358" ></v-checkbox>
                        </v-col>
                        <v-col>
                        </v-col>
                    </v-row>
                    </v-container>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn color="success" @click="generar_reporte_sqs" >
                    <v-icon>done</v-icon>Generar Reporte
                    </v-btn>
                </v-card-actions>

                <v-card-text>
                    <v-refresh-button :funcion="cargarReportes" />
                    <v-client-table ref="vuetable" :data="datos" :columns="columns" :options="options" class="elevation-2 pa-2" >
                    <template slot="noResults" >
                        <v-alert :value="true" icon="info" color="info" >No se encontró ningún registro</v-alert>
                    </template>

                    <template slot="criterio" slot-scope="props" >
                        <div class="columnaCriterio" >
                        {{ props.row.criterio }}
                        </div>
                    </template>

                    <template slot="actions" slot-scope="props" >
                        <v-btn text icon color="primary" title="Descargar" v-if="props.row.estatus=='Generado Correctamente' && props.row.filename!='' " @click="downloadFile(props.row.filename)" >
                        <v-icon dark>get_app</v-icon>
                        </v-btn>
                        <v-btn text icon color="red" title="Eliminar" v-if="permisoEliminar" @click="eliminarReporte(props.row.id)" >
                        <v-icon dark>delete</v-icon>
                        </v-btn>
                    </template>
                    </v-client-table>
                </v-card-text>

            </base-material-card>
        </v-flex>
    </v-layout>
    </v-container>

</div>

</template>

<script>
import axios from "axios";
import moment from "moment";
import RefreshButton from "@/components/RefreshButton.vue";

export default {
  components: {
    "v-refresh-button": RefreshButton,
  },
  data: () => ({
    es_grupo:0,
    clientesTransportista:[],
    rfc_cliente_seleccionado:"",
    gruposTransportistas:[],
    rfc_grupo_seleccionado:"",
    fecha_factura: false,
    dialog1: false,
    lista_filtrada: [],
    permisoEliminar: false,
    fab: false,
    loading_claves: true,
    breadcrumbs: [{
        text: "Inicio",
        disabled: false,
        to: "/indext"
      },
      {
          text: "Reporte Directo Archivos M",
          disabled: true,
          to: "",
      },
    ],
    datos: [],
    columns: ["id", "fecha_solicitud", "usuario_email", "nombre_reporte", "criterio", "fecha_generacion", "estatus", "error", "actions"],
    options: {
      filterable: ["id", "fecha_solicitud", "usuario_email", "nombre_reporte", "criterio", "fecha_generacion", "estatus", "error"],
      sortable: ["id", "fecha_solicitud", "usuario_email", "nombre_reporte", "criterio", "fecha_generacion", "estatus", "error"],

      headings: {
        id: "No. Proceso",
        fecha_solicitud: "Solicitado",
        usuario_email: "Usuario",
        nombre_reporte: "Reporte",
        criterio: "Criterio de Búsqueda",
        fecha_generacion: "Generado",
        estatus: "Estatus",
        error: "Error",
        actions: "Descargar"
      }
    },
    show_loading: true,

    model: {
      rfc: "",
      usuario: "",
      fecha_de: "",
      fecha_a: "",
      tablas: [],
      reporte_url: "/reportes_vucem/directo_archivo_m_transportista/",
      nombre_reporte: "Consulta Directa ArchivoM",
      tipo: "Directo_ArchivoM_Transportista",
    },

    selecciona_todo: false,


    menu1: false,
    menu2: false,

    rules: {
      required: v => !!v || "Este campo es requerido",
      numeric: value => {
        const pattern = /^[\d]*$/;
        return pattern.test(value) || "Solo se permiten números";
      }
    }
  }),

  methods: {
    getNombreGrupo:function(row){
        return row.rfc+" - "+row.grupo;
    },
    getTransportistas: function(){            
        let data = {
            id_cliente: this.$local_storage.get("id_cliente"),                
        };
        axios.post(this.$hostname+ "grupos/get_grupos_rfc/", data)            
            .then(res => {
                if (typeof res.data !== "undefined") {
                    this.gruposTransportistas = res.data;
                    
                }
            })
            .catch(err => {
                this.$swal({
                    type: "error",
                    title: "¡Operación no Permitida!",
                    text: "Ocurrió un error al obtener los grupos.",
                    footer: ""
                });
                console.log(err);
            });
    },
    getNombreCliente:function(row){
        if(row.metadato!=null && row.metadato!="")
            return row.rfc+" - "+row.metadato;
        else
            return row.rfc+" - "+row.razon_social;
    },
    getClientesTransportista: function(){
        let data = {
            id_grupo: this.$local_storage.get("id_grupo"),                
        };
        axios.post(this.$hostname+ "grupos/get_rfcs/", data)            
            .then(res => {
                if (typeof res.data !== "undefined") {
                    this.clientesTransportista = res.data;                        
                }
            })
            .catch(err => {
                this.$swal({
                    type: "error",
                    title: "¡Operación no Permitida!",
                    text: "Ocurrió un error al obtener los clientes.",
                    footer: ""
                });
                console.log(err);
            });
    },
    validaDias: function () {
        if (this.model.fecha_de != "" && this.model.fecha_a != "") {
            var inicio = moment(this.model.fecha_de, "YYYY-MM-DD");
            var fin = moment(this.model.fecha_a, "YYYY-MM-DD");
            var diferencia = fin.diff(inicio, "days");
            if (diferencia < 0)
                return "La Fecha Final no debe ser menor a la Fecha Inicial.";
            if (Math.abs(diferencia) > 365)
                return "Periodo máximo de consulta 365 dias. Favor de verificar.";
        }
        return true;
    },
    validaFecha: function(fecha) {
      if (fecha == "Invalid date")
        return "Fecha no válida."

      return true;
    },
    validaAnio: function() {
      if (this.model.fecha_de != "" && this.model.fecha_a != "") {
        var inicio = moment(this.model.fecha_de, "YYYY-MM-DD");
        var fin = moment(this.model.fecha_a, "YYYY-MM-DD");
        var diferencia = fin.diff(inicio, 'days')
        if (diferencia < 0)
          return "La Fecha Final no debe ser menor a la Fecha Inicial."
      }
      return true;
    },

    verificaTablas: function() {
      if (this.model.tablas.length == 0)
        return "Debe seleccionar al menos una tabla";
      else
        return true;
    },

    pushTable: function(tabla) {
      var i = this.model.tablas.indexOf(tabla);
      if (i !== -1) {
        this.model.tablas.splice(i, 1);
      } else
        this.model.tablas.push(tabla);
    },
    seleccionaTodo: function() {
      if (this.selecciona_todo == true) {
       if (this.es_grupo==0)
            this.model.tablas = ["501", "502", "503", "504", "505", "506", "507", "508", "509", "510", "511", "512",
              "513", "514", "515", "516", "560",
              "601", "301", "302", "351", "352", "353", "355", "358","800",
            "520", "551", "552", "553", "554", "555", "556", "557", "558",
            "701", "702"];
       else
            this.model.tablas = ["501", "502", "503", "504", "505", "551"];
      } else {
        this.model.tablas = [];
      }
    },
    cargarReportes: function() {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      let data = {
        rfc: this.model.rfc,
        "tipo": "Directo_ArchivoM_Transportista"
      };
      axios.post(this.URL + "get_reportes/", data)
        .then(res => {
          if (typeof res.data !== "undefined") {
            this.datos = res.data;
            this.datos.sort(function(a, b) {
              //Ordenar por fecha más reciente
              return new Date(b.fecha_solicitud) - new Date(a.fecha_solicitud);
            });
            for (var k in this.datos) {
              this.datos[k].fecha_solicitud = this.parseDate(this.datos[k].fecha_solicitud);
              this.datos[k].fecha_generacion = this.parseDate(this.datos[k].fecha_generacion);
              this.datos[k].estatus = this.getEstatus(this.datos[k].estatus);
              this.datos[k].criterio = this.getCriterioPredeterminadosDS(this.datos[k].criterio);
            }
          }
        })
        .catch(err => {
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: "Ocurrió un error al obtener los reportes ds.",
            footer: ""
          });
          console.log(err);

        }).then(() => {
          this.$root.$dialogLoader.hide();
        });
    },

    getEstatus: function(estatus) {
      var arr_estatus = ["Pendiente", "Encolado", "Generado Correctamente", "Con Errores"];
      if (estatus in arr_estatus)
        return arr_estatus[estatus];
      else
        return "N/A";
    },
    getCriterioPredeterminadosDS: function(criterio) {
      try {
        if (criterio != undefined && criterio.toString().trim() != "") {
          var params = JSON.parse(criterio);
          var result = ""
          if (params.pedimento !=null && params.pedimento != "")
            result += "\nPedimento: " + params.pedimento;
          else {
            if (params.lista != undefined && params.lista != "" && params.lista.length > 0) {
              result += "Búsqueda por Lista.";
            } else {
              result += "Fecha De: " + params.fecha_de + ", " + "Fecha A: " + params.fecha_a;

            }
            if (params.rfc_emisor != undefined && params.rfc_emisor != "")
              result += "\nRFC: " + params.rfc_emisor + ", ";            
          }
          if (params.tablas != undefined && params.tablas.length > 0) {
            if (params.tablas.length == 37)
              result += "\nTodas las secciones";
            else {
              result += "\nSecciones: " + params.tablas;
            }
          }

          return result;
        } else {
          return "N/A";
        }
      } catch (error) {
        console.log(error);
        return "N/A-error";
      }
    },

    generar_reporte_sqs() {
      if (!this.$refs.form.validate()) {
        //Alguna operación o mensaje
      } else {

        this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');

        var data = this.model;

        data["es_grupo"] = this.es_grupo;
        
        if(this.rfc_grupo_seleccionado!=null && this.rfc_grupo_seleccionado!="")
            data["rfc_emisor"] = this.rfc_grupo_seleccionado;
        else 
            data["rfc_emisor"] = "";

        if(this.rfc_cliente_seleccionado!=null && this.rfc_cliente_seleccionado!="")
            data["rfc_cliente"] = this.rfc_cliente_seleccionado;
        else 
            data["rfc_cliente"] = "";
        
        axios({
            method: "post",
            url: this.$hostname + "reportes/save_reporte/",            
            data: data
          })
          .then(response => {
            this.$swal({
              type: "success",
              title: "Operación Exitosa",
              text: "El reporte se está generando. Cuando esté listo recibirá una notificación",
              footer: ""
            });
          })
          .catch(error => {
            let mensaje;
            var titulo = "¡Operación no Permitida!";
            var tipo = "error";
            if (typeof error.response !== "undefined") {
              mensaje = error.response.data.mensaje;
              if (error.response.status == 406) {
                titulo = "¡Ya existe un reporte en proceso!";
                tipo = "info";
              }
            } else {
              mensaje = "Ocurrió un error al generar el reporte";
            }
            this.$swal({
              type: tipo,
              title: titulo,
              text: mensaje,
              footer: ""
            });
          }).then(() => {
            this.model.lista = '';
            this.lista_filtrada = [];
            this.cargarReportes();
            this.$root.$dialogLoader.hide();
          });
      }
    },
    parseDate(date) {
      //Formato  YYYY-MM-DD
      if (!date) return null;
      return moment(String(date)).format("YYYY-MM-DD");
    },
    parseDateTime(date) {
      //Formato  YYYY-MM-DD
      if (!date) return null;
      return moment(String(date)).format("YYYY-MM-DD HH:mm:ss");
    },

    downloadFile: function(key) {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      var datos = {
        id: key,
        bucket: "production.econnect.ds"
      }
      axios.post(this.$hostname + 's3/download_url/', datos)
        .then((res) => {
          if (typeof res.data !== 'undefined') {
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            a.href = res.data.mensaje;
            a.target = "_blank";
            a.click();
            a.parentNode.removeChild(a);

          } else {
            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
              footer: '',
            });
          }
        })
        .catch((error) => {
          var mensaje = "Ocurrió un error al descargar el archivo";
          if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
            mensaje = error.response.data.mensaje;
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: mensaje,
            footer: '',
          });
          console.log(error);
        }).then(() => {
          this.$root.$dialogLoader.hide();
        });
    },
    eliminarReporte: function(idreporte) {
      this.$swal({
        type: "info",
        title: "Cuidado",
        text: "¿Está seguro de eliminar el reporte con No. Proceso: " + idreporte + "?",
        footer: "",
        showCancelButton: true,
        cancelButtonColor: "#d33",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar"
      }).then(result => {
        if (result.value) {
          this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
          var datos = {
            id_reporte: idreporte,
          }
          axios.post(this.$hostname + 'reportes/eliminar_reporte/', datos)
            .then((res) => {
              this.$swal({
                type: "success",
                title: "Operación Exitosa",
                text: "El reporte se eliminó correctamente",
                footer: ""
              });
            })
            .catch((error) => {
              this.$swal({
                type: "error",
                title: "¡Operación no Permitida!",
                text: "Ocurrió un error al eliminar el reporte. Favor de comunicarse con soporte.",
                footer: '',
              });
              console.log(error);
            }).then(() => {
              this.$root.$dialogLoader.hide();
              this.cargarReportes();
            });
        }
      });

    },

  }, //methods
  created: function() {
    this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
    this.URL = this.$hostname + "reportes/";
    this.model.usuario = this.$local_storage.get("id_usuario");
    
    var tipoUsuario = this.$local_storage.get("tipo_usuario");
    if (tipoUsuario == "Soporte" || tipoUsuario == "Super Usuario" || tipoUsuario == "Grupo")
      this.permisoEliminar = true;

      if (this.$local_storage.get("es_transportista") == 1 || this.$local_storage.get("es_agente") == 1) {
        this.model.rfc = this.$local_storage.get("rfc_grupo");  
        this.es_grupo = 1;
        this.getClientesTransportista();                   
    } else {
        this.model.rfc = this.$local_storage.get("rfc");
        this.getTransportistas();
    }

    this.cargarReportes();
  }
};
</script>

<style scoped>
.elevation-1>>>.v-label.theme--light {
  color: black !important;
}



.elevation-1>>>.columnaCriterio {
  white-space: normal !important;
  min-width: 400px !important;
  text-align: justify !important;
}
</style>
